import { useEffect, useState } from "preact/hooks";
import { route } from "preact-router";
import { STRINGS } from "../constants/strings";
import { toErrorPath } from "../routes";

export function useTokenConfirmation<T extends { status: string }>(
  fetcher: (token: string) => Promise<T>,
  handle: (res: T) => void
): string | null {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      route(toErrorPath("invalid"), true);
      return;
    }
    let cancelled = false;
    fetcher(token)
      .then((res) => {
        if (cancelled) return;
        if (res.status === "rate_limited") {
          setError(STRINGS.resendRateLimit);
          return;
        }
        handle(res);
      })
      .catch(() => {
        if (!cancelled) setError(STRINGS.genericError);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return error;
}
